import { useEffect, useState } from 'react'
import { mappedArray } from '@10000/common'
import { useRequest, useView } from '@10000/react'
import { Body, Box, Button, Expertise, H3, PracticePie } from '../../widgets'
import { useShell } from '../../layout'
import { practiceAverages } from '../../../utilities.js'
import { practices } from '../../../lookups'
import { ConfirmExit, SquizButton } from '../common'
import './Recap.scss'

export const Recap = ({ active, displayMode }) => {
  const [section, setSection] = useState(-1)
  const [rotateSection, setRotateSection] = useState(-1)
  const [complete, setComplete] = useState(false)
  const [confirmExit, setConfirmExit] = useState(false)
  const { presenter, teamAverages, options: { kiosk, free } } = useView('squiz')
  const values = practiceAverages(teamAverages)
  const request = useRequest('squiz')

  useShell({ active, mode: (presenter && !kiosk) ? 'authenticated' : 'logo' })

  useEffect(() => {
    const handle = setInterval(
      () => setSection(current => {
        if(current === 4) {
          clearInterval(handle)
          setTimeout(() => setComplete(true), 1500)
        } else {
          setTimeout(() => setRotateSection(current + 1), 1500)
        }
        return current + 1
      }),
      2000
    )
    return () => clearInterval(handle)
  }, [])

  const visibleValues = mappedArray(6, i => i <= section ? values[i] : -1)
  const rotate = -30 - (rotateSection + 1) * 60

  const showAnalytics = () => request('analyticsStarted')

  const exit = () => {
    setConfirmExit(false)
    return request('squizExited')
  }

  return <>
    <Box
      column
      fullWidth
      fullHeight
      pt={90}
      alignItems="center"
      gap={40}
      overflow="hidden"
      className={`recap${complete ? ' complete' : ''}`}
    >
      <Box opacity={section === -1 ? 0 : 1} transition="0.5s" className="expertise">
        {complete
          ? <Box column alignItems="center" justifyContent="center" gap={16}>
              <H3>This is us</H3>
              <Body alt bold>Let&apos;s deep dive</Body>
            </Box>
          : <Expertise
              title={practices[section]?.name}
              value={values[section]}
              practice={section}
            />
        }
      </Box>

      <Box grow maxHeight="calc(100vw - 20px)" aspect="1/1" rotate={rotate} transition="0.5s">
        <PracticePie values={visibleValues} hoverEffect={false} />
      </Box>


      {!displayMode &&
        <Box
          column
          gap={16}
          fullWidth
          maxWidth={400}
          className="buttons"
          p="16px 32px"
          opacity={complete ? 1 : 0}
          transition="0.5s"
          alignItems="center"
          zIndex={1}
        >
          {presenter
            ? <>
                <Button fullWidth onClick={showAnalytics}>
                  Show analytics
                </Button>
                {(!kiosk && !free) &&
                  <SquizButton
                    onClick={() => setConfirmExit(true)}
                    text="End Squiz"
                  />
                }
              </>
            : <Body alt bold>Waiting on host...</Body>
          }
        </Box>
      }
      <ConfirmExit
        open={confirmExit}
        onCancel={() => setConfirmExit(false)}
        onConfirm={exit}
      />
    </Box>
  </>
}